// Katalog písem nabízených v administraci vzhledu. Klíče musí odpovídat
// App\Services\ThemeService::FONTS (backend vrací povolené klíče přes ThemeTL::getThemeOptions()).
// Písma se načítají lokálně (@fontsource, bez volání třetích stran) a leniwě — až když je některé
// téma opravdu použije.

export type ThemeFont = {
	key: string;
	label: string;
	/** hodnota pro `font-family` */
	css: string;
	/** `serif` / `sans` — jen pro popisek v editoru */
	kind: 'serif' | 'sans';
	load?: () => Promise<unknown>;
};

export const themeFonts: ThemeFont[] = [
	{ key: 'system', label: 'Systémové', css: 'system-ui, sans-serif', kind: 'sans' },
	{ key: 'georgia', label: 'Georgia', css: 'Georgia, "Times New Roman", Times, serif', kind: 'serif' },
	{
		key: 'inter', label: 'Inter', css: '"Inter Variable", system-ui, sans-serif', kind: 'sans',
		load: () => import('@fontsource-variable/inter'),
	},
	{
		key: 'roboto', label: 'Roboto', css: 'Roboto, system-ui, sans-serif', kind: 'sans',
		load: () => Promise.all([import('@fontsource/roboto/400.css'), import('@fontsource/roboto/700.css')]),
	},
	{
		key: 'source-sans-3', label: 'Source Sans 3', css: '"Source Sans 3 Variable", system-ui, sans-serif', kind: 'sans',
		load: () => import('@fontsource-variable/source-sans-3'),
	},
	{
		key: 'merriweather', label: 'Merriweather', css: '"Merriweather Variable", Georgia, serif', kind: 'serif',
		load: () => import('@fontsource-variable/merriweather'),
	},
];

export const findThemeFont = (key: string): ThemeFont => themeFonts.find(f => f.key === key) ?? themeFonts[0];

const loaded = new Set<string>();

/** Načte soubory písma (jednou). Chyby se ignorují — vykreslí se záložní písmo z `css`. */
export const loadThemeFont = async (key: string): Promise<void> => {
	const font = findThemeFont(key);
	if (!font.load || loaded.has(font.key)) return;
	loaded.add(font.key);
	try {
		await font.load();
	} catch {
		loaded.delete(font.key);
	}
};
